<template>
    <el-button
        :key="key"
        :disabled="disabled"
        class="download-templateCustom-custom button-cancel"
        @click="downloadTemplate"
    >
        <i class="icon-gongyong_xiazai" />
        <span>{{ text }}</span>
    </el-button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "下载模板"
    },

    templatePath: { // 相对"./public/importTemplate/"的路径
      type: String,
      require: true
    },

    templateName: {
      type: String,
      default: "模板"
    }
  },

  data() {
    return {
      key: `DownloadTemplateCustomID-${Math.random()
        .toString(36)
        .slice(2)}`
    };
  },

  methods: {
    downloadTemplate() {
      const fileUrl = `./importTemplate/${this.templatePath}`;
      let link = document.createElement("a");

      link.style.display = "none";
      link.href = fileUrl;
      link.setAttribute("download", this.templateName);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style lang="scss">
    .download-templateCustom-custom {
        padding: 0 15px 0 12px;
        width: auto;
        display: inline-flex;
        align-items: center;
        i {
            margin-right: 6px;
            font-size: 9px;
        }
    }
</style>